export class CountryModel{
    public label: string;
    public value: string;
    public name: string;
  }

  export class customeModel{
    public label: string;
    public value: number;
    public name: string;
  }

   export class optionStringModel{
    public label: string;
    public value: string;
    public name: string;
  }

   export class specialCustomeModel{
    public label: string;
    public value: number;
    public name: string;
    public isBold: boolean;
  }


  export class memberModel{
    public label: string;
    public value: boolean;
    public name: string;
  }